import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Selectors from "../Selectors";
import ActionCreator from "../ActionCreator";

class NavIconButton extends Component {
  render() {
    let { badge = false, img, profile, itemInCart } = this.props;

    if (!badge) {
      return (
        <Wrapper>
          <img src={`/images/pages/navbar/icon-${img}.png`} />
        </Wrapper>
      );
    }

    return (
      <Wrapper>
        <img src={`/images/pages/navbar/icon-${img}.png`} />
        <div className="total">{profile ? itemInCart : 0}</div>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  & > img {
    width: 23px;
    height: 23px;
  }

  & > .total {
    display: flex;
    align-items: center;
    justify-content: center;

    margin-left: 3px;
    border-radius: 14.5px;
    padding: 2px;
    min-width: 20px;
    height: 20px;
    background: #bd9f84;
    font-size: 14px;
    color: white;
  }
`;

export default connect(
  (state, ownProps) => ({
    profile: Selectors.getLoginUser(state),
    itemInCart: (() => {
      let total = 0;
      if (Selectors.getCartData(state)) {
        total = Selectors.getCartData(state).items.length;
      }

      return total;
    })()
  }),
  ActionCreator
)(NavIconButton);
